import { useCallback, useEffect, useState } from 'react';
import { isEmpty } from 'ramda';
import { cursorFetchMore } from 'utils/paginationHelper';
import { EDGES_PATH } from 'constants/dataPaths';
var SCROLL_GAP = 10;
var useScroll = function (_a) {
    var dataPath = _a.dataPath, fetchMore = _a.fetchMore, pageInfo = _a.pageInfo, _b = _a.dataType, dataType = _b === void 0 ? EDGES_PATH : _b, scrollRef = _a.scrollRef, isHorizontalScroll = _a.isHorizontalScroll, isTable = _a.isTable, tableId = _a.tableId, filterUniqueIds = _a.filterUniqueIds;
    var _c = useState(false), scrollLoading = _c[0], setScrollLoading = _c[1];
    var hasNextPage = pageInfo.hasNextPage;
    // Fetch on demand
    useEffect(function () {
        if (scrollLoading) {
            cursorFetchMore(fetchMore)({
                dataPath: dataPath,
                pageInfo: pageInfo,
                dataType: dataType,
                setScrollLoading: setScrollLoading,
                filterUniqueIds: filterUniqueIds
            });
        }
    }, [scrollLoading]);
    var getScrollParams = function (event) {
        var target = event.target;
        var scrollHeight = target.scrollHeight, scrollWidth = target.scrollWidth, clientHeight = target.clientHeight, clientWidth = target.clientWidth, scrollTop = target.scrollTop, scrollLeft = target.scrollLeft;
        if (isHorizontalScroll) {
            return {
                realSize: scrollWidth,
                sizeInView: clientWidth,
                scrollOffset: scrollLeft
            };
        }
        // verticalScrollParams
        return {
            realSize: scrollHeight,
            sizeInView: clientHeight,
            scrollOffset: scrollTop
        };
    };
    // Scroll handler
    var handleScroll = useCallback(function (event) {
        var _a = getScrollParams(event), realSize = _a.realSize, sizeInView = _a.sizeInView, scrollOffset = _a.scrollOffset;
        var maxScrolling = realSize - sizeInView;
        var isHandleFetch = hasNextPage && maxScrolling - scrollOffset <= SCROLL_GAP;
        if (isHandleFetch)
            setScrollLoading(true);
    }, [hasNextPage]);
    var getScrollNode = function () {
        if (tableId) {
            return document.querySelector("[data-id=\"".concat(tableId, "\"] .ant-table-body"));
        }
        if (isTable) {
            return document.querySelector('.ant-table-body');
        }
        return scrollRef.current;
    };
    // Scroll listener
    useEffect(function () {
        if (isEmpty(pageInfo))
            return function () { };
        var scrollNode = getScrollNode();
        if (!scrollNode)
            return function () { };
        scrollNode.addEventListener('scroll', handleScroll);
        return function () { return scrollNode.removeEventListener('scroll', handleScroll); };
    }, [handleScroll, scrollRef]);
    return { scrollLoading: scrollLoading };
};
export default useScroll;
